const yup = require("yup");

const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

const formatDate = (date) => {
    date = new Date(date);
    let dd = date.getDate();
    if (dd < 10) dd = "0" + dd;
    let mm = date.getMonth() + 1;
    if (mm < 10) mm = "0" + mm;
    return dd + "/" + mm + "/" + date.getFullYear();
};

const formatPhoneNumber = (v) => {
    if (!v) return "";
    let trim = v.replace(/[^A-Z0-9]/ig, "");
    if (trim.length === 11) trim = trim.substring(1, trim.length);
    return trim;
};

const yearsAgo = (years) => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setFullYear(date.getFullYear() - years);
    return date;
};

const AGE_MINIMUM = 19;

const verifyOpts = {
    sms: {
        label: "SMS",
        value: "sms",
    },
    email: {
        label: "Courriel",
        value: "email",
    },
    call: {
        label: "Appel téléphonique",
        value: "call",
    },
    skip: {
        label: "Ignorer",
        value: "skip",
    },
};

export const version = "1.1.8";
export const fixedHeight = true;
export const transformers = {
    dob: (val) => formatDate(val),
    phoneNumber: (val) => formatPhoneNumber(val),
};
export const steps = {
    desired_vehicle: {
        title: "Quel type de véhicule recherchez-vous ?",
        inputs: [
            {
                key: "desiredVehicle",
                type: "choice",
                options: [
                    {
                        label: "Voiture",
                        value: "car",
                    },
                    {
                        label: "Camion",
                        value: "truck",
                    },
                    {
                        label: "VUS",
                        value: "suv",
                    },
                    {
                        label: "Mini-fourgonnette",
                        value: "mini van",
                    },
                ],
                validations: yup.string().required("Veuillez sélectionner une option"),
                cy: {
                    critical: [0],
                },
            },
        ],
        nextStep: "date_of_birth",
        expectedTime: 5, //seconds
    },

    date_of_birth: {
        title: "Quelle est votre date de naissance ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "dob",
                label: "JJ/MM/AAAA",
                type: "date",
                validations: yup
                    .date()
                    .required("La date de naissance est obligatoire")
                    .typeError("Veuillez entrer une date valide")
                    .min(
                        new Date(1900, 0, 1),
                        "Veuillez entrer une date valide",
                    )
                    .max(
                        yearsAgo(AGE_MINIMUM),
                        `Vous devez avoir ${AGE_MINIMUM} ans ou plus`,
                    ),
                cy: {
                    correct: "01/01/1980",
                    wrong: "01/01{enter}",
                },
            },
        ],
        nextStep: "estimate_credit_rating",
        expectedTime: 20, //seconds
    },

    estimate_credit_rating: {
        title: "Selon vous, quelle est la qualité de votre crédit actuel ?",
        inputs: [
            {
                key: "estimateCreditRating",
                type: "choice",
                options: [
                    {
                        label: "Excellent",
                        value: "great",
                    },
                    {
                        label: "Bon",
                        value: "good",
                    },
                    {
                        label: "Passable",
                        value: "fair",
                    },
                    {
                        label: "Faible",
                        value: "poor",
                    },
                    {
                        label: "Je ne sais pas",
                        value: "I'm not sure",
                    },
                ],
                validations: yup.string().required("Veuillez sélectionner une option"),
            },
        ],
        nextStep: "employment_status",
        expectedTime: 5,
    },

    employment_status: {
        title: "Quelle est votre situation d'emploi actuelle ?",
        inputs: [
            {
                key: "employmentStatus",
                type: "choice",
                options: [
                    {
                        label: "Employé",
                        value: "employed",
                    },
                    {
                        label: "Travailleur autonome",
                        value: "self-employed",
                    },
                    {
                        label: "Étudiant",
                        value: "student",
                    },
                    {
                        label: "Autre",
                        value: "other",
                    },
                ],
                validations: yup.string().required("Veuillez sélectionner une option"),
                cy: {
                    critical: [0, 2, 3],
                },
            },
        ],
        nextStep: "monthly_income",
        expectedTime: 5, // seconds
    },

    monthly_income: {
        title: "Quel est votre revenu mensuel actuel ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "monthlyIncome",
                label: "Revenu mensuel",
                type: "number",
                validations: yup
                    .number()
                    .typeError("Le revenu mensuel doit être un nombre")
                    .required("Le revenu mensuel est obligatoire")
                    .min(2000, "Le revenu mensuel doit être de 2000 ou plus"),
                cy: {
                    correct: 4000,
                },
            },
        ],
        nextStep: "income_time",
        expectedTime: 10, // seconds
    },

    income_time: {
        title: "Depuis combien de temps gagnez-vous ce revenu ?",
        inputs: [
            {
                key: "incomeTime",
                type: "choice",
                options: [
                    {
                        label: "3 mois - 1 an",
                        value: "3 Months - 1 Year",
                    },
                    {
                        label: "1 an - 3 ans",
                        value: "1 Year - 3 Years",
                    },
                    {
                        label: "3 ans - 5 ans",
                        value: "3 Years - 5 Years",
                    },
                    {
                        label: "Plus de 5 ans",
                        value: "over 5 years",
                    },
                ],
                validations: yup
                    .string()
                    .required("Veuillez sélectionner une option")
                    .matches(
                        /(3 Months - 1 Year|1 Year - 3 Years|3 Years - 5 Years|over 5 years)/,
                        "La durée doit être d'au moins 3 mois",
                    ),
                cy: {
                    critical: [0],
                },
            },
        ],
        nextStep: "employer_info",
        expectedTime: 5, // seconds
    },

    employer_info: {
        title: "Parfait! Qui est votre employeur ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "companyName",
                label: "Employeur",
                type: "string",
                validations: yup.string().required("L'employeur est obligatoire"),
                cy: {
                    correct: "Google",
                },
            },
            {
                key: "position",
                label: "Poste",
                type: "string",
                validations: yup.string().required("Le poste est obligatoire"),
                cy: {
                    correct: "CSR",
                },
            },
        ],
        nextStep: "address",
        expectedTime: 15, //seconds
    },

    address: {
        title: "Parfait! Quelle est votre adresse de domicile ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "address",
                label: "Adresse",
                type: "address",
                useGrid: true /* for manual address inputs */,
                validations: yup.object(
                    {
                        address: yup.string().required(),
                        postalCode: yup.string().required(),
                        city: yup.string().required(),
                        provinceCode: yup.string().required(),
                    },
                    "Veuillez sélectionner une adresse valide",
                ),
            },
        ],
        cy: {
            overrideNext: {
                key: "manual_address",
                continue: (cy) => {
                    cy.getCy("address_container")
                        .parent()
                        .getCy("manual")
                        .click();
                },
            },
        },
        nextStep: "residence_time",
        expectedTime: 10,
    },

    residence_time: {
        title: "Depuis combien de temps habitez-vous à cette adresse ?",
        inputs: [
            {
                key: "residenceTime",
                type: "choice",
                options: [
                    {
                        label: "Moins de 2 ans",
                        value: "less than 2 years",
                    },
                    {
                        label: "Plus de 2 ans",
                        value: "over 2 years",
                    },
                ],
                validations: yup.string().required("Veuillez sélectionner une option"),
                cy: {
                    critical: [0],
                },
            },
        ],
        nextStep: "name",
        expectedTime: 5, //seconds
    },

    name: {
        title: "Quel est votre nom ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "firstName",
                label: "Prénom",
                type: "string",
                validations: yup
                    .string()
                    .required("Le prénom est obligatoire")
                    .min(2, "Le prénom est trop court")
                    .max(20, "Le prénom est trop long"),
                cy: {
                    correct: "First Name",
                },
            },
            {
                key: "lastName",
                label: "Nom de famille",
                type: "string",
                validations: yup
                    .string()
                    .required("Le nom de famille est obligatoire")
                    .min(2, "Le nom de famille est trop court")
                    .max(20, "Le nom de famille est trop long"),
                cy: {
                    correct: "Last Name",
                },
            },
        ],
        nextStep: "email",
        expectedTime: 10, //seconds
    },

    email: {
        title: "Quelle adresse courriel souhaitez-vous utiliser ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "email",
                label: "Courriel",
                type: "string",
                validations: yup
                    .string()
                    .required("Le courriel est obligatoire")
                    .email("Le format du courriel n'est pas valide"),
                cy: {
                    correct: "test@email.com",
                    wrong: "wrongemail.com",
                },
            },
        ],
        nextStep: "phone_number",
        expectedTime: 10, // seconds
    },

    phone_number: {
        title: "Quel est le meilleur numéro de téléphone pour vous joindre ?",
        continueButtonText: "Continuer",
        inputs: [
            {
                key: "phoneNumber",
                label: "Numéro de téléphone",
                type: "tel",
                validations: yup
                    .string()
                    .required("Le numéro de téléphone est obligatoire")
                    .matches(phoneRegExp, "Le numéro de téléphone n'est pas valide"),
                cy: {
                    correct: 5555555555,
                },
            },
        ],
        nextStep: (context, configValue) => {
            const verifyMethods = configValue("twilioVerifyMethods");
            return verifyMethods.length === 1
                ? "verify_code"
                : "verify_options";
        },
        expectedTime: 10, //seconds
    },

    verify_options: {
        title: "Nous aimerions vérifier votre identité",
        description: (context, configValue) => {
            const isVerifyRequired = configValue("twilioVerifyRequired");
            const skipMessage = isVerifyRequired
                ? ""
                : "Vous pouvez ignorer cette étape.";
            return `Veuillez sélectionner l'une des méthodes de vérification ci-dessous. ${skipMessage}`;
        },
        inputs: (context, configValue) => {
            const isVerifyRequired = configValue("twilioVerifyRequired");
            const verifyMethods = configValue("twilioVerifyMethods");
            const verifyOptions = verifyMethods.map((method) => {
                return verifyOpts[method];
            });
            if (!isVerifyRequired) {
                verifyOptions.push(verifyOpts["skip"]);
            }
            return [
                {
                    key: "verifyOptions",
                    type: "choice",
                    options: verifyOptions,
                    validations: yup
                        .string()
                        .required("Veuillez sélectionner une option"),
                    cy: {
                        critical: [0],
                    },
                },
            ];
        },
        nextStep: (context) =>
            context.verifyOptions === "skip" ? "submit" : "verify_code",
        expectedTime: 5, //seconds
    },

    verify_code: {
        title: (context, configValue) => {
            const verifyMethods = configValue("twilioVerifyMethods");
            if (verifyMethods.length === 1) {
                switch (verifyMethods[0]) {
                    case "sms":
                        return `Entrez le code de vérification envoyé au ${context.phoneNumber} par SMS`;
                    case "email":
                        return `Entrez le code de vérification envoyé à votre courriel : ${context.email}`;
                    case "call":
                        return `Entrez le code de vérification reçu par téléphone au ${context.phoneNumber}`;
                }
            } else {
                return context.verifyOptions === "email"
                    ? `Entrez le code de vérification envoyé à votre courriel : ${context.email}`
                    : context.verifyOptions === "sms"
                      ? `Entrez le code de vérification envoyé au ${context.phoneNumber} par SMS`
                      : `Entrez le code de vérification reçu par téléphone au ${context.phoneNumber}`;
            }
        },
        inputs: [
            {
                key: "verifyCode",
                type: "verify-code",
            },
        ],
        nextStep: "submit",
        expectedTime: 5, //seconds
    },

    submit: {
        title: "C'est presque terminé !",
        inputs: (_, configValue) => [
            {
                key: "authorized",
                type: "submit-blurb",
                body1: `En cliquant sur le bouton « SOUMETTRE », j'ai lu et accepté les Conditions d'utilisation de ${configValue("name")}. Je confirme également avoir lu la Politique de confidentialité et en accepter les conditions.`,
            },
        ],
        hideSubmit: false,
        continueButtonText: "Soumettre",
        nextStep: "success",
        expectedTime: 10,
    },

    success: {
        inputs: [
            {
                key: "success",
                type: "presentational-success",
                title: "Succès!",
                body: "C'est terminé! Votre demande a été soumise avec succès. L'un de nos centres d'approbation communiquera avec vous sous peu.",
            },
            {
                type: "presentational-success-ctas",
                compact: false,
            },
        ],
        nextStep: null,
    },
};
